"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormColumnsController", {
    enumerable: true,
    get: function() {
        return FormColumnsController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _formcolumnsservice = require("~/services/form-columns.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let FormColumnUpdateReqType = class FormColumnUpdateReqType {
};
let FormColumnsController = class FormColumnsController {
    async columnUpdate(context, formViewColumnId, formViewColumnbody, req) {
        return await this.formColumnsService.columnUpdate(context, {
            formViewColumnId,
            formViewColumn: formViewColumnbody,
            req
        });
    }
    constructor(formColumnsService){
        this.formColumnsService = formColumnsService;
    }
};
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/form-columns/:formViewColumnId',
        '/api/v2/meta/form-columns/:formViewColumnId'
    ]),
    (0, _extractidsmiddleware.Acl)('formViewUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('formViewColumnId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof FormColumnUpdateReqType === "undefined" ? Object : FormColumnUpdateReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], FormColumnsController.prototype, "columnUpdate", null);
FormColumnsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _formcolumnsservice.FormColumnsService === "undefined" ? Object : _formcolumnsservice.FormColumnsService
    ])
], FormColumnsController);
